// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"be360e90","112":"2f9221a9","453":"e820a502","455":"bab2213a","461":"29811637","492":"d9860e41","526":"60873a2d","694":"ea0f0667","718":"41894e6f","864":"d3f02f4d","885":"c001ff2d","931":"d24ca580","977":"883c5e24"}[chunkId] + ".chunk.js";
};